import { TOKEN_KEY } from '../enums/cacheEnum';

// 需要保存pageSize的页面
export const STORAGE_TABLE_INFO_PAGE = {
  // task Index Subpage
  myTaskManagement: 'myTaskManagement',
  teamTaskManagement: 'teamTaskManagement',
  shareTask: 'shareTask',
  projectList: 'projectList',
  projectDetailTasks: 'projectDetailTasks',
  notifyIndexTeam: 'notifyIndexTeam',
  notifyIndexNews: 'notifyIndexNews',
  modelDetailRuns: 'modelDetailRuns',
  teamBilling: 'teamBilling',
  teamManagementMembers: 'teamManagementMembers',
  teamManagementGroups: 'teamManagementGroups',
  teamManagementGroupInfo: 'teamManagementGroupInfo',
} as const;

export const STORAGE_KEY = {
  // localStorage
  lang: 'lang',
  groupSearchUserId: 'groupSearchUserId',
  firstMaskSubscribe: 'firstMaskSubscribe',
  userGuilds: 'userGuilds',
  datasetEditors: 'datasetEditors',
  hasShowTaskWelcome: 'hasShowTaskWelcome',
  hasShowMyTaskManageWelcome: 'hasShowMyTaskManageWelcome',
  localTeamId: 'localTeamId',
  firstMaskClick: 'firstMaskClick',
  selectPartnerTag: 'selectPartnerTag',
  defaultColumn: 'defaultColumn',
  teamActiveKey: 'teamActiveKey',
  memberSearchRole: 'memberSearchRole',
  [TOKEN_KEY]: TOKEN_KEY,
  myTaskToDo: 'myTaskToDo',
  //需要保存pageSize的页面
  ...STORAGE_TABLE_INFO_PAGE,
  rememberFilter: 'rememberFilter',
  taskManagementFilter: 'taskManagementFilter',
  sharedTaskListFilter: 'sharedTaskListFilter',
  hasBeenShowed: 'hasBeenShowed',

  // sessionStorage
  breadcrumbType: 'breadcrumbType',
  breadcrumbTitle: 'breadcrumbTitle',
  showBeta: 'showBeta',
  loginEmail: 'loginEmail',
  taskListActiveTab: 'taskListActiveTab',
  projectDetailScroll: 'projectDetailScroll',

  lastReminder: 'lastReminder',
  firstLoginModalMap: 'firstLoginModalMap',
  firstMaskClickMap: 'firstMaskClickMap',
};
